module.exports = __webpack_public_path__ + "static/img/1204_sur.538dddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo_sur/1204_sur.png
// module id = 3R0M
// module chunks = 0